import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-fi",
  "use": "icon-flag-fi-usage",
  "viewBox": "0 0 1546 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1546 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-fi\"><defs><style type=\"text/css\"></style></defs><path d=\"M11.322 1017.71h1520.904V6.29H11.322v1011.42zM1536 1021.484v-3.774 3.774zM5.032 1024V0h1533.484v1024H5.032z\" fill=\"#353636\" p-id=\"5521\" /><path d=\"M8.806 2.516H1536v1017.71H8.806z\" fill=\"#FFFFFF\" p-id=\"5522\" /><path d=\"M1536 384.943H691.892V2.516H436.52v382.427H8.806v254.114H436.52v382.427h255.37V639.057H1536z\" fill=\"#006EAE\" p-id=\"5523\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-fi.svg
// module id = 8naE
// module chunks = 24